export const parseQueryString = function (name, url = window.location.href) {
    const regex = new RegExp("[?&]" + name + "=([^&#]*)", "i");
    const match = url.match(regex);
    return match ? safeDecodeURIComponent(match[1]) : null;
};

// 安全解码URI组件，处理无效编码的情况
export const safeDecodeURIComponent = function (encodedString) {
    try {
        return decodeURIComponent(encodedString);
    } catch (e) {
        // 处理无效编码的情况，直接返回原始字符串
        return encodedString;
    }
};
